import { useState, useEffect, useRef } from "react";

function About() {
  const [openSection, setOpenSection] = useState("specialists");
  const [inView, setInView] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setInView(entry.isIntersecting);
      },
      { threshold: 0.05 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <div id="about" className="min-h-screen container mx-auto p-4 md:p-8">
      {/* Recommendation Statement */}
      <div className="flex flex-col md:flex-row items-start gap-8">
        
        {/* Left - Doctor's Image */}
        <div
          ref={sectionRef}
          className={`w-full md:w-1/2 flex justify-center p-4 md:p-8 transition-opacity duration-700 ${
            inView ? "opacity-100" : "opacity-0"
          }`}
          style={{ minHeight: "400px" }} // Keeps the image container stable
        >
          <img
            src="/images/srikanth.webp"
            alt="Dr. Srikanth - Best Urologist in Bangalore"
            className="w-full max-w-xs md:max-w-sm h-auto object-cover rounded-2xl shadow-lg"
          />
        </div>

        {/* Right - Accordion Section */}
        <div
          className={`w-full md:w-1/2 transition-opacity duration-700 flex-grow ${
            inView ? "opacity-100" : "opacity-0"
          }`}
        >
          <h2 className="text-2xl md:text-xl font-bold text-center md:text-left mb-4">
            <p>
              <img className="inline" src="/images/dr_srikanth.jpg" alt="Dr. Srikanth V - Experienced Urologist" />
              (17+ Years Experience)
            </p>
          </h2>

          {/* Accordion */}
          <div className="border rounded-lg shadow-md bg-white">
            
            {/* Areas of Expertise Section */}
            <div>
              <button
                className="w-full text-left p-4 bg-gray-200 hover:bg-gray-300 font-semibold"
                onClick={() => setOpenSection(openSection === "specialists" ? "" : "specialists")}
              >
                Areas of Expertise:
              </button>
              {openSection === "specialists" && (
                <div className="p-4 bg-white border-t">
                  <ul className="list-disc list-inside">
                    <li>RIRS (Retrograde Intrarenal Surgery for Kidney Stones)</li>
                    <li>Andrology & Male Fertility</li>
                    <li>Female Urology & Reconstructive Surgery</li>
                    <li>Prostate Laser Treatment</li>
                    <li>Kidney Transplant Services</li>
                    <li>Urethral Stricture Treatment</li>
                    <li>Phimosis & Circumcision Treatment</li>
                    <li>Uro-oncology (Urological Cancer Treatment)</li>
                    <li>Robotic Urological Surgery</li>
                    <li>✅ 248+ Patients Recommended | 98% Recommendation Score</li>
                  </ul>
                </div>
              )}
            </div>

            {/* Languages Spoken */}
            <div>
              <button
                className="w-full text-left p-4 bg-gray-200 hover:bg-gray-300 font-semibold"
                onClick={() => setOpenSection(openSection === "speak" ? "" : "speak")}
              >
                Languages Spoken:
              </button>
              {openSection === "speak" && (
                <div className="p-4 bg-white border-t">
                  <ul className="list-disc list-inside">
                    <li>English</li>
                    <li>Hindi</li>
                    <li>Kannada</li>
                    <li>Tamil</li>
                    <li>Telugu</li>
                  </ul>
                </div>
              )}
            </div>

            {/* Academic Information Section */}
            <div>
              <button
                className="w-full text-left p-4 bg-gray-200 hover:bg-gray-300 font-semibold"
                onClick={() => setOpenSection(openSection === "academic" ? "" : "academic")}
              >
                Qualifications & Certifications:
              </button>
              {openSection === "academic" && (
                <div className="p-4 bg-white border-t block">
                  <ul className="list-disc list-inside">
                    <li>MBBS - Bachelor of Medicine & Surgery</li>
                    <li>MS - General Surgery</li>
                    <li>DNB - Genito-Urinary Surgery</li>
                    <li>KMC Registration No. 80155</li>
                  </ul>
                </div>
              )}
            </div>

          </div>
        </div>
      </div>

      {/* 100% Recommended Badge */}
      <p className="text-center text-lg text-gray-600 font-semibold mb-6 p-4">
        ⭐ 100% Recommended Urologist on Medintu, Practo, and Apollo ⭐
      </p>
    </div>
  );
}

export default About;
